var React = require('react');

var $ = require("jquery");

var ReactDOM = require('react-dom');

var _ = require("underscore");

var Tip = require("../cutil/Tip");

var { get_productDescribeList } = require('../util/productDescribeService');

var {ProductTableContainer, Cell,CellTitle, CellContent } = require('./ProductTableContainer');

var visaHintInfo = require("../conf/visa-hint-info");

var InsuranceClauseDialog = require("./InsuranceClauseDialog");
var noAppointRoomKind =true;

/**
 * 处理 extra 的 map (高阶函数)
 */
 var mapExtraProps = function (data,iteratee) {

    if(!_.isObject(data)){
        return null
    }

    return iteratee( data )

};


/**
 * 备注信息展示
 */
 var RemarksDescribe = ({remarks})=>
 remarks && remarks.length
 ?
 <ul className="remarks">
 {
    remarks.map( (remark, index)=>
        <li className="item" key={index} dangerouslySetInnerHTML={{__html: remark}}></li>)
}
</ul>
:   <noscript/>


/**
 * 签证查看链接
 */
 var VisaBtn = ({poi_id,poi_name})=>
 poi_id ? <div className="visa-hint">
 <p><a className="btn-primary"
 href={`//www.xcds.com.cn/topic/special/visa-${poi_id}-pc/`}>查看{ poi_name }签证办理注意事项</a></p>
 { 
  visaHintInfo(poi_id) ? <p className="visa-hint-txt"><em>* { visaHintInfo(poi_id) }</em></p> : <noscript/>
}   
</div>
: <noscript/>

/**
 * 提示信息
 */
 var ProductTips = ({tips})=>
 tips? <p className="info">* { tips }</p>
 : <noscript/>


/**
 * 商品描述信息并带有数目统计
 * @param {object} props
 * @param {object} props.data - 商品的数据
 * @param {string} props.productType - 商品的类型
 */
 var ProductDescribe= ({ data, tips, productType, hasNum})=>
 <ul className="item-list">
 {

    get_productDescribeList(data, productType).map( ({pid, name, name_tags,notices,num,remarks,extra}, index) =>

        <li className="item" key={index}  >
        <span className="item-name" dangerouslySetInnerHTML={{__html: name}}></span>
        {
            name_tags ? (
                _.map(name_tags,function(item,index){
                   return (<span className="item-num" key = {"spec-" + index}>{ item }</span>)  
                })
            ) : null
        }
        {
            hasNum && productType
            ?<span className="item-num">{ num }</span>
            : null
        }
        <RemarksDescribe remarks={ remarks }  />
        {
            mapExtraProps(extra, ({poi_id,poi_name})=> <VisaBtn poi_id={ poi_id } poi_name={ poi_name } /> )
        }
        {
          productType == "insurance" ?
          <InsuranceClauseDialog pid={ pid } pname={ name } />
          : null
      }

      {notices ?(
            <div>

            {
                notices.tips ? ( 
                  <dl className="cell-serve-standard cell-serve-standard-span">
                  <dt> {notices.title}</dt>
                  <dd>
                  <ul>
                  {
                  _.map(notices.tips, function(item,index) {
                    return(

                        <li key={index}>
                        <span className="title">{item.k} ：</span>
                        <span>{item.v}</span>
                        </li>
                        )
                     })
                  }
                  </ul>
                  </dd>
                  </dl>
                  ): null

            }

            {
                notices.special_desc ? (
                  <dl className="cell-serve-standard cell-serve-standard-span">

                  <dd>
                  {
                  _.map(notices.special_desc,function(n,i){
                    return(

                        <p key={"spec-" + i}  className="special_desc_box">
                        <i className="icon-super-detail-usertip"></i>
                        <span> {n} </span>
                        </p>    

                        )
                })
                  }

                  </dd>
                  </dl>
                  ) : null    

            }

            {
                notices.special_tips_list ? (
                    <div>
                    
                    {
                        _.map(notices.special_tips_list,function(e,j){
                            return(
                                <dl className="cell-serve-standard cell-serve-standard-span" key={"spectip-" + j} >
                                    <dd>
                                        <p className='title'>
                                            {e.title}
                                        </p> 
                                        <p >
                                            {e.desc}
                                        </p>    
                                    </dd>
                                </dl>

                             )
                        })
                    }
                    </div>
                    
                    ) : null    

            }
            </div>

            ): null}

      </li>

      )
}
<li>
<ProductTips tips={tips} />
</li>
</ul>


/**
 * 详细的商品描述信息包括天数,名称,总数,备注
 * @param {object} props
 * @param {object} props.data - 商品的数据
 * @param {string} props.productType - 商品的类型
 * @param {string} props.hasFullName - 是否显示全名
 */
 var ProductDescribeDetail = ({data, productType, tips, hasFullName, hasNum})=>

 <ul className="item-list">
 {
    get_productDescribeList(data, productType).map(({day, name,name_tags, fullName,num, remarks,notices}, index)=>

        <li className="item" key={ index }>
        {
            day ? <span className="item-day">{ day }</span> :null

        }

        <span className="item-name" dangerouslySetInnerHTML={{__html: hasFullName? fullName : name}}></span>

        {
            name_tags ? (
                _.map(name_tags,function(item,index){
                   return (<span className="item-num" key = {"spec-" + index}>{ item }</span>)  
                })
            ) : null
        }
        {
            hasNum && num ?<span className="item-num">{ num }</span> : null
        }
        <RemarksDescribe remarks={ remarks }  />


        {notices ?(
            <div>

            {
                notices.tips ? ( 
                  <dl className="cell-serve-standard cell-serve-standard-span">
                  <dt> {notices.title}</dt>
                  <dd>
                  <ul>
                  {
                  _.map(notices.tips, function(item,index) {
                    return(

                        <li key={index}>
                        <span className="title">{item.k} ：</span>
                        <span>{item.v}</span>
                        </li>
                        )
                     })
                  }
                  </ul>
                  </dd>
                  </dl>
                  ): null

            }

            {
                notices.special_desc ? (
                  <dl className="cell-serve-standard cell-serve-standard-span">

                  <dd>
                  {
                  _.map(notices.special_desc,function(n,i){
                    return(

                        <p key={"spec-" + i}  className="special_desc_box">
                        <i className="icon-super-detail-usertip"></i>
                        <span> {n} </span>
                        </p>    

                        )
                })
                  }

                  </dd>
                  </dl>
                  ) : null    

            }

            {
                notices.special_tips_list ? (
                    <div>
                    
                    {
                        _.map(notices.special_tips_list,function(e,j){
                            return(
                                <dl className="cell-serve-standard cell-serve-standard-span" key={"spectip-" + j} >
                                    <dd>
                                        <p className='title'>
                                            {e.title}
                                        </p> 
                                        <p >
                                            {e.desc}
                                        </p>    
                                    </dd>
                                </dl>

                             )
                        })
                    }
                    </div>
                    
                    ) : null    

            }
            </div>

            ): null}

        </li>
        )
}
<li>
<ProductTips tips={tips} />
</li>
</ul>

var HotelDescribeDetailA = ({data, productType, tips, hasFullName, hasNum})=>

<ul className="item-list">
{
    get_productDescribeList(data, productType).map(({day, name,name_tags, fullName,num, remarks,notices,person}, index)=>

        <li className="item" key={ index }>
        {
            day ? <span className="item-day">{ day }</span> :null

        }
        <span className="item-name" dangerouslySetInnerHTML={{__html: hasFullName? fullName : name}}></span>
        {
            name_tags ? (
                _.map(name_tags,function(item,index){
                   return (<span className="item-num" key = {"spec-" + index}>{ item }</span>)  
                })
            ) : null
        }
        {
            hasNum && num ?<span className="item-num">{ num }</span> : null
        }
        
        <RemarksDescribe remarks={ remarks }  />


        
        {notices ?(
            <div>

            {
                notices.tips ? ( 
                  <dl className="cell-serve-standard cell-serve-standard-span">
                  <dt> {notices.title}</dt>
                  <dd>
                  <ul>
                  {
                  _.map(notices.tips, function(item,index) {
                    if(item.k == "指定房型"){noAppointRoomKind = false}
                    return(

                        <li key={index}>
                        <span className="title">{item.k} ：</span>
                        <span>{item.v}</span>
                        </li>
                        )
                     })
                  }
                  </ul>
                  </dd>
                  </dl>
                  ): null

            }

            {
                notices.special_desc ? (
                  <dl className="cell-serve-standard cell-serve-standard-span">

                  <dd>
                  {
                  _.map(notices.special_desc,function(n,i){
                    return(

                        <p key={"spec-" + i}  className="special_desc_box">
                        <i className="icon-super-detail-usertip"></i>
                        <span> {n} </span>
                        </p>    

                        )
                })
                  }

                  </dd>
                  </dl>
                  ) : null    

            }

            {
                notices.special_tips_list ? (
                    <div>
                    
                    {
                        _.map(notices.special_tips_list,function(e,j){
                            return(
                                <dl className="cell-serve-standard cell-serve-standard-span" key={"spectip-" + j} >
                                    <dd>
                                        <p className='title'>
                                            {e.title}
                                        </p> 
                                        <p >
                                            {e.desc}
                                        </p>    
                                    </dd>
                                </dl>

                             )
                        })
                    }
                    </div>

                    
                    ) : null    

            }
            </div>

            ): null}

        {noAppointRoomKind && index == data.length-1 && person ? (
            <dl className="cell-serve-standard">
            <dd>
            {person[1] == "0" ? (
                <span>
                您未指定房型（大床房、双床房等）。在预定时填写的房型偏好仅能视住宿库存等因素而定，无法100%保证。如您对房型有严格要求，请联系旅行顾问指定，指定后价格很可能发生变化。</span>): (
                <span>
                此住宿为儿童不占床、不加床的价格，如要占床、可加床房型（加床后可能拥挤），请联系旅行顾问指定。入住时现场加床或升级房型，住宿方会视房型、库存等因素才能决定，由此产生的费用须由您现场支付，行程大师无法提前代缴。
                </span>)    }


                <div className="hotel-extra-box">
                <Tip trigger={
                    <span>
                    <span className="hotel-extra c-blue">指定房型建议</span>
                    <i className="icon-super-detail-info-b" style={{verticalAlign: '-2px'}}></i>
                    </span>
                } enter>
                <HotelAppointExtra/>
                </Tip>
                </div>
                </dd>
                </dl>
                ):null
    }

    </li>
    )
}
<li>
<ProductTips tips={tips} />
</li>
</ul>
/**
 * 航班信息描述
 */
 var AirPlaneExtra = ({ airports,maxRouteCnt, maxRouteCntDesc })=>
 <div className="c-tip-content quote-hint-box">
 <div className="c-head">
 <i className="icon-super-detail-tip-2"/>
 精选航空公司
 </div>
 <div className="c-body">
 <ul className="air-plane-info-wrap">
 {
    _.map(airports, function(item,index){
        if(index >14){
            return null
        }
        return(
            <li className="air-plane-item" key={index}>
            <img src={item.logo} alt="" width="15" height="15"/>{item.name}
            </li>
            )
    })
}
</ul>
</div>
{+maxRouteCnt>=0 ? (
    <div>
    <div className="c-head">
    <i className="icon-super-detail-tip-2"/>
    转机次数
    </div>
    <div className="c-body">
    <div className="f-normal">
    {
        maxRouteCnt === 1?(
            <span>单程不超过1次</span>
            ):(
            <span>直飞</span>
            )
        }

        </div>
        </div>
        <div className="c-head">
        <i className="icon-super-detail-tip-2"/>
        单程转机间隔时间
        </div>
        <div className="c-body">
        <div className="f-normal">{maxRouteCntDesc}</div>
        </div>
        </div>
        ): null}

<div className="c-footer">
<p className="info"><strong>温馨提示：</strong></p>
<p className="info f-s">
行程大师将在综合考虑飞行舒适度、航空公司服务和安全纪录、价格等各种因素后，为您精心挑选与旅行方案最匹配性价比最高的国际航班。
</p>
</div>

</div>

/**
 * 转机信息展示
 */
 var TransferFlightInfo = ({plantInfo, day,name,name_tags, num, isInland})=>
 <div>
 {plantInfo && +plantInfo.maxRouteCnt>=0 ? (
    <div>
    {
        isInland && day && <span className="item-day">{ day }</span>
    }
    <span className="item-name" dangerouslySetInnerHTML={{__html: name}}></span>
    {
        ! isInland && name_tags == "严选" ?(  <span>
            <span className="plane-route-cnt">(单程转机次数≤1次)</span>
            <Tip trigger={ <i className="icon-super-detail-info-b"></i>} enter>
            <AirPlaneExtra  { ...plantInfo } />
            </Tip>
            </span>) :null
    }
    {
        num ?<span className="item-num">{ num }</span> : null
    }
    {
        name_tags ? <span className="item-num">{ name_tags }</span> : null
    }
    </div>
    ) : (
    <div>
    {
        plantInfo && ! isInland
        ? ( <div>
            <span className="item-name" dangerouslySetInnerHTML={{__html: name}}></span>
            <Tip trigger={ <i className="icon-super-detail-info-b"></i>} enter>
            <AirPlaneExtra  { ...plantInfo } />
            </Tip>
            </div>)
        : ( <div><span className="item-name" dangerouslySetInnerHTML={{__html: name}}></span></div> )
    }
    {
        num ?<span className="item-num">{ num }</span> : null
    }
    {
        name_tags ? <span className="item-num">{ name_tags }</span> : null
    }
    </div>
    )}
    </div>

/**
 * 判断机票是否为内陆航段
 */
 var isInland = function (extra) {

    if( !_.isObject(extra) || typeof extra.inland === 'undefined' ){
        return false
    }

    return !!extra.inland

};

/**
 * 机票描述信息
 * @param {object} props
 * @param {object} props.data - 商品的数据
 * @param {string} props.plantInfo - 机票信息
 */
 var AirTicketDescribe = ({data, plantInfo, hasNum,absent})=>
 <ul className="item-list">
 {
    get_productDescribeList(data, 'air').map(({day, name,name_tags, num, extra,notices}, index)=>
        <li className="item" key={ index }>
        <TransferFlightInfo plantInfo={ plantInfo }
        TransferFlightInfo  isInland={ isInland(extra) }
        day={day}
        name={name}
        name_tags = {name_tags}
        num={ hasNum ? num : undefined }/>


        {notices ?(
            <div>

            {
                notices.tips ? ( 
                  <dl className="cell-serve-standard cell-serve-standard-span">
                  <dt> {notices.title}</dt>
                  <dd>
                  <ul>
                  {
                  _.map(notices.tips, function(item,index) {
                    return(

                        <li key={index}>
                        <span className="title">{item.k} ：</span>
                        <span>{item.v}</span>
                        </li>
                        )
                     })
                  }
                  </ul>
                  </dd>
                  </dl>
                  ): null

            }

            {
                notices.special_desc ? (
                  <dl className="cell-serve-standard cell-serve-standard-span">

                  <dd>
                  {
                  _.map(notices.special_desc,function(n,i){
                    return(

                        <p key={"spec-" + i}  className="special_desc_box">
                        <i className="icon-super-detail-usertip"></i>
                        <span> {n} </span>
                        </p>    

                        )
                })
                  }

                  </dd>
                  </dl>
                  ) : null    

            }

            {
                notices.special_tips_list ? (
                    <div>
                    
                    {
                        _.map(notices.special_tips_list,function(e,j){
                            return(
                                <dl className="cell-serve-standard cell-serve-standard-span" key={"spectip-" + j} >
                                    <dd>
                                        <p className='title'>
                                            {e.title}
                                        </p> 
                                        <p >
                                            {e.desc}
                                        </p>    
                                    </dd>
                                </dl>

                             )
                        })
                    }
                    </div>
                    
                    ) : null    

            }
            </div>

            ): null}

        {!absent && !notices && index == data.length-1 ?(
            <dl className="cell-serve-standard">
            <dt>选航班，我们有三享！</dt>
            <dd>
            <ul>
            <li>
            <p className="title">注重安全，享安心</p>
            <p>
            不选低评级航空，<br/>
            旅行玩耍好心情，怎能为航空安全担惊受怕？
            </p>
            </li>
            <li>
            <p className="title">追求优质，享舒心</p>
            <p>
            长途旅行飞那么久，当然得舒适！<br/>
            国际段航班不使用廉价航空，懂你对品质的要求。
            </p>
            </li>
            <li>
            <p className="title">远离折腾，享省心</p>
            <p>
            我们选用的国际段航班，转机次数≤1次，<br/>
            严格控制转机时长，不浪费宝贵的旅行时间。
            </p>
            </li>
            </ul>
            </dd>
            </dl>
            ) :null}

        </li>

        )
}
</ul>

/**
 * 酒店清单展示
 */
 var HotelExtra = ({extra}) =>
 <div className="c-tip-content quote-hint-box">
 <div className="c-head">
 <i className="icon-super-detail-tip-2"/>
 酒店清单
 </div>
 <div className="c-body">
 <ul className="hotel-extra-wrap">
 {
    _.map(extra, function(item,index){
        return(
            <li className="hotel-item" key={index}>
            <span className="item-icon">o</span>&nbsp;&nbsp;{item.name}
            </li>
            )
    })
}
</ul>
</div>
</div>

/**
 * 酒店未指定提示
 */
 var HotelAppointExtra = () =>
 <div className="c-tip-content quote-hint-box">
 <div className="c-head">
 <i className="icon-super-detail-tip-2"/>
 指定房型建议
 </div>
 <div className="c-body">
 <ul className="hotel-extra-wrap">
 <li>1、两位为情侣或夫妻关系，可视情况指定大床或者双床；若无需要可以不指定；</li>
 <li>2、两位为同性普通朋友出行，建议提前指定双床房；</li>
 <li>3、三位成年人一间房，建议提前指定三人间；</li>
 <li>4、两位成年人携带2位小孩，建议预定两间房；如果只要一间房，请提前和旅行顾问沟通询问细节</li>
 </ul>
 </div>
 </div>

/**
 * 酒店的商品描述,增添了酒店清单的弹框
 * @param {object} props
 * @param {object} props.data - 酒店的数据
 */
 var HotelDescribeDetail = ({data,hasNum})=>
 <ul className="item-list">
 {
    get_productDescribeList(data, 'hotel').map(({day, name, num, remarks, extra,notices,person}, index)=>

        <li className="item" key={ index }>
        {
            day ? <span className="item-day">{ day }</span> :null
        }
        <span className="item-name" dangerouslySetInnerHTML={{__html: name}}></span>
        {
            hasNum && num ?<span className="item-num">{ num }</span> : null
        }
        <div className="hotel-extra-box">
        <Tip trigger={
            <span>
            <span className="hotel-extra c-blue">酒店清单</span>
            <i className="icon-super-detail-info-b"></i>
            </span>
        } enter>
        <HotelExtra extra={extra} />
        </Tip>
        </div>
        <RemarksDescribe remarks={ remarks }  />

        
        {notices ?(
            <div>

            {
                notices.tips ? ( 
                  <dl className="cell-serve-standard cell-serve-standard-span">
                  <dt> {notices.title}</dt>
                  <dd>
                  <ul>
                  {
                  _.map(notices.tips, function(item,index) {
                    if(item.k == "指定房型"){noAppointRoomKind = false}
                    return(

                        <li key={index}>
                        <span className="title">{item.k} ：</span>
                        <span>{item.v}</span>
                        </li>
                        )
                     })
                  }
                  </ul>
                  </dd>
                  </dl>
                  ): null

            }

            {
                notices.special_desc ? (
                  <dl className="cell-serve-standard cell-serve-standard-span">

                  <dd>
                  {
                  _.map(notices.special_desc,function(n,i){
                    return(

                        <p key={"spec-" + i}  className="special_desc_box">
                        <i className="icon-super-detail-usertip"></i>
                        <span> {n} </span>
                        </p>    

                        )
                })
                  }

                  </dd>
                  </dl>
                  ) : null    

            }

            {
                notices.special_tips_list ? (
                    <div>
                    {
                        _.map(notices.special_tips_list,function(e,j){
                            return(
                                <dl className="cell-serve-standard cell-serve-standard-span" key={"spectip-" + j} >
                                    <dd>
                                        <p className='title'>
                                            {e.title}
                                        </p> 
                                        <p >
                                            {e.desc}
                                        </p>    
                                    </dd>
                                </dl>

                             )
                        })
                    }
                    </div>
                    
                    ) : null    

            }
            </div>

            ): null}

        {noAppointRoomKind && index == data.length-1 && person ? (
            <dl className="cell-serve-standard">
            <dd>

            {
                person[1] == "0" ? (
                    <span>
                    您未指定房型（大床房、双床房等）。在预定时填写的房型偏好仅能视住宿库存等因素而定，无法100%保证。如您对房型有严格要求，请联系旅行顾问指定，指定后价格很可能发生变化。</span>): (
                    <span>
                    此住宿为儿童不占床、不加床的价格，如要占床、可加床房型（加床后可能拥挤），请联系旅行顾问指定。入住时现场加床或升级房型，住宿方会视房型、库存等因素才能决定，由此产生的费用须由您现场支付，行程大师无法提前代缴。
                    </span>)    }


                    <div className="hotel-extra-box">
                    <Tip trigger={
                        <span>
                        <span className="hotel-extra c-blue">指定房型建议</span>
                        <i className="icon-super-detail-info-b" style={{verticalAlign: '-2px'}}></i>
                        </span>
                    } enter>
                    <HotelAppointExtra/>
                    </Tip>
                    </div>
                    </dd>
                    </dl>
                    ):null
    }

    </li>

    )
}


</ul>

module.exports = {
    ProductDescribe,
    ProductDescribeDetail,
    AirTicketDescribe,
    HotelDescribeDetail,
    HotelDescribeDetailA
};



/** WEBPACK FOOTER **
 ** ./script/detail/ProductDescribe.jsx
 **/